const transformMarketingPref = value => (value === 'yes' ? 1 : null);

export default transformMarketingPref;
